import createHTMLElement from '../services/create-element.js';

const addScript = () => {
  const src = window.Site.human.src;

  if (!src) {
    return;
  }

  const script = createHTMLElement(`script`, {
    src,
    async: true,
    'data-pgi-dis-hold': `hmnsPgiEvent`,
  });

  document.head.appendChild(script);
};

const creatGlobalObject = () => {
  const regExp = window.Site.human.regExp;
  const targeting = window.Site.targeting || {};

  if (!regExp) {
    return;
  }

  window.hmnsPgiEvent = {
    dispatch: (arg) => {
      const hmnsRegex = new RegExp(regExp);
      const IVTDetected = !hmnsRegex.test(arg.value);

      targeting.IVT = IVTDetected ?? false;
    },
  };
};

export const initHuman = () => {
  const isHumanEnabled = window.Site.human;

  if (!isHumanEnabled) {
    return;
  }

  creatGlobalObject();
  addScript();
};
